import analyticsEvent from 'services/analytic/analytic-service';

export const sendAnalyticsEvent = ({ gaLabel = '' } = {}) => {
  analyticsEvent({
    gaAction: 'Product Page - Ways to pay',
    gaLabel,
  });
};
